export default [
    {
        name: 'cadastro-limite-mensagem',
        path: 'limite-mensagem',
        redirect: 'limite-mensagem/index',
        component: () => import(/* webpackChunkName: 'cadastro-limite-mensagem' */ '@/views/cadastro/limite-mensagem/Index'),
        children: [
            {
                meta: {title: 'Limites mensais de mensagens'},
                name: 'cadastro-limite-mensagem-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-limite-mensagem' */ '@/views/cadastro/limite-mensagem/List.vue'),
            },
            {
                meta: {title: 'Cadastro de limite mensal de mensagens'},
                name: 'cadastro-limite-mensagem-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-limite-mensagem' */ '@/views/cadastro/limite-mensagem/Form.vue'),
            },
            {
                meta: {title: 'Edição de limite mensal de mensagens'},
                name: 'cadastro-limite-mensagem-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-limite-mensagem' */ '@/views/cadastro/limite-mensagem/Form.vue'),
            },
        ],
    },
]
